import type { PropsWithChildren } from 'react';
import { createContext, useContext, useMemo } from 'react';

import { useCheckout } from '@jane/shared-ecomm/providers';
import { useHeadlessApp } from '@jane/shared/providers';

interface HeadlessKioskContextValue {
  isHeadlessKioskMode: boolean;
}

const HeadlessKioskContext = createContext<HeadlessKioskContextValue>(
  // Return default values when not wrapped in provider (for non-kiosk flows)
  {
    isHeadlessKioskMode: false,
  }
);
HeadlessKioskContext.displayName = 'HeadlessKiosk';

export const useHeadlessKiosk = () => useContext(HeadlessKioskContext);

export const HeadlessKioskProvider = ({ children }: PropsWithChildren) => {
  const {
    appInfo: { isEmbeddedMode },
  } = useCheckout();
  const {
    options: { kiosk },
  } = useHeadlessApp();

  const isHeadlessKioskMode = isEmbeddedMode && kiosk === true;

  const value = useMemo(
    () => ({
      isHeadlessKioskMode,
    }),
    [isHeadlessKioskMode]
  );

  return (
    <HeadlessKioskContext.Provider value={value}>
      {children}
    </HeadlessKioskContext.Provider>
  );
};
